export const SLOT = {
  HEAD:     'head',
  FACE:     'face',
  TORSO:    'torso',
  WAIST:    'waist',
  FOOT_L:   'foot_left',
  FOOT_R:   'foot_right',
  HAT:      'hat',
} as const;
